import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
import { IUserObjectAsGiftCardSubscription } from '../../../entity/interface/iDiscounts';
import { AxiosError } from 'axios';
export interface ISubscribeViaGiftCardUseCase {
    execute(
        discountCode: string,
        username: string,
        lang: string,
        password: string,
        tierGuid: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IUserObjectAsGiftCardSubscription>;
}

export class SubscribeViaGiftCardUseCase implements ISubscribeViaGiftCardUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subViaGiftCard(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        discountCode: string,
        username: string,
        lang: string,
        password: string,
        tierGuid: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IUserObjectAsGiftCardSubscription> {
        const response = await this.subViaGiftCard.subscribeViaGiftCard(
            discountCode,
            username,
            lang,
            password,
            tierGuid,
            csrfToken
        );
        if (response.data) {
            return response.data;
        }
        throw new AxiosError('Invalid response from API', '500');
    }
}
